import Slider from "../Slider/Slider"

interface ZoomSliderProps {
    onChange: (value: number) => void
    min: number
    max: number
    step: number
    disabled?: boolean
    value: number
    mode: string
    className?: string
}

export const ZoomSlider = ({
    onChange,
    min,
    max,
    step,
    disabled = false,
    value = 0,
    mode,
}: ZoomSliderProps) => {
    return (
        <div>
            <Slider
                key={mode}
                min={min}
                max={max}
                step={step}
                disabled={disabled}
                value={value}
                onChange={(e) => onChange(Number(e.target.value))}
            />
        </div>
    )
}
